<template>
  <div id="email-notifications">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Email Notification Templates'"/>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="5"
        :menuItems="commonMenuItems.admin"
      />
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
        >
        <a-list class="demo-loadmore-list" itemLayout="horizontal" :dataSource="emailNotificaitonList">
          <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
            <router-link slot="actions" :to="{ name: 'admin-email-notification-template', params: { 'templateId': item.id } }">Edit</router-link>
            <a-list-item-meta
              :description="item.description"
            >
              <router-link slot="title" :to="{ name: 'admin-email-notification-template', params: { 'templateId': item.id } }">{{item.title}}</router-link>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import dashHeader from '@src/views/dashboard/Header.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';

export default {
  name: 'email-notifications',
  data() {
    return {
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Email Notifications',
          route: '/dashboard/email-notifications',
        },
      ],
      emailNotificaitonList: [
        {
          id: 'new-user-welcome-email-template',
          title: 'Invitation to complete the user profile.',
          description: 'Email from TELAS admin to users after registration.',
        },
        {
          id: 'profile-completion-notification-email-template',
          title: 'Confirmation of profile completion',
          description: 'Email from TELAS admin to users to confirm the completion of user profile.',
        },
        {
          id: 'admin-to-self-assessor-email-template',
          title: 'Admin to a Self-Assessor',
          description: 'Email from TELAS admin to a Self-Assessor (Not sent from TELAS app)',
        },
        {
          id: 'course-submitter-approval-email-template',
          title: 'Course Submitter Approval',
          description: 'Email from TELAS admin to Course Submitter (Approve user)',
        },
        {
          id: 'interim-reviewer-approval-email-template',
          title: 'Interim Reviewer Approval',
          description: 'Email from TELAS admin to Interim Reviewer (Approve User)',
        },
        {
          id: 'new-course-submitted-email-template',
          title: 'New Course Submitted',
          description: 'New Course Submitted e-mail to TELAS admin',
        },
        {
          id: 'admin-reviewer-assigned-email-template',
          title: 'Admin Reviewer Assigned',
          description: 'Email from TELAS admin to an Admin Reviewer (Admin Review)',
        },
        {
          id: 'first-reviewer-assigned-email-template',
          title: 'First Reviewer Assigned',
          description: 'Email from TELAS admin to First Reviewer (First Review)',
        },
        {
          id: 'second-reviewer-assigned-email-template',
          title: 'Second Reviewer Assigned',
          description: 'Email from TELAS admin to Second Reviewer (Second Review)',
        },
        {
          id: 'interim-reviewer-assigned-email-template',
          title: 'Interim Reviewer Assigned',
          description: 'Email from TELAS admin to Interim Reviewer (Interim Review)',
        },
        {
          id: 'combined-review-request-email-template',
          title: 'Combined Review Request',
          description: 'Email from TELAS admin to First Reviewer (Combined Review)',
        },
        {
          id: 'eligibility-for-course-accreditation-email-template',
          title: 'Eligibility for Course Accreditation',
          description: 'Email from TELAS admin to Course Submitter (applying for course accreditation)',
        },
        {
          id: 'non-eligible-for-course-accreditation-email-template',
          title: 'Non Eligible for Course Accreditation',
          description: 'Email from TELAS admin to Course Submitter (when course fails to meet minimum score for accreditation)',
        },
        {
          id: 'user-role-change-email-template',
          title: 'User role change',
          description: 'Email from TELAS admin to users when their role is changed.',
        },
      ],
    };
  },
  components: {
    dashHeader,
    dashSidebar,
  },
};
</script>
